<template>
    <div>
        <div class="header pt-5 px-3">
            <div>
                {{ headerText }}
            </div>
            <div>
                <v-btn
                    @click="cancel()"
                    outlined
                    class="mr-2"
                    width="150"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.visitorForm.cancel') }}
                </v-btn>

                <v-btn
                    :disabled="!branchId"
                    @click="submit()"
                    width="150"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.visitorForm.save') }}
                </v-btn>
            </div>
        </div>

        <v-form
            lazy-validation
            ref="form"
            v-model="valid">
            <v-container>
                <v-row>
                    <v-col cols="8">
                        <v-card class="visitor-profile px-10 py-5 content-container">
                            <v-row>
                                <v-col
                                    cols="12"
                                    class="visitor-profile-text-box">
                                    <span class="visitor-profile-text locale-font">
                                        {{ $vuetify.lang.t('$vuetify.visitorForm.profile') }}
                                    </span>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <div class="d-flex-center">
                                        <profile
                                            :isEditing="true"
                                            @change-profile-img="changeProfileImg"
                                            :img="form.image"/>
                                    </div>
                                    <div class="image-size-info"><center>{{ $vuetify.lang.t('$vuetify.visitorForm.msgImageSize') }}</center></div>
                                </v-col>
                                <v-col cols="9">
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field
                                                v-model="form.citizen_id"
                                                :label="$vuetify.lang.t('$vuetify.visitorForm.citizenId')"
                                                autocomplete="off"
                                                placeholder=" "
                                                :rules="inputRules"
                                                :error-messages="errors.citizen_id">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field
                                                v-model="form.name"
                                                :label="$vuetify.lang.t('$vuetify.visitorForm.name')"
                                                autocomplete="off"
                                                placeholder=" "
                                                :rules="inputRules"
                                                :error-messages="errors.name">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field
                                                v-model="form.surname"
                                                :label="$vuetify.lang.t('$vuetify.visitorForm.surname')"
                                                autocomplete="off"
                                                placeholder=" "
                                                :rules="inputRules"
                                                :error-messages="errors.surname">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field
                                                v-model="form.card_no"
                                                :label="$vuetify.lang.t('$vuetify.visitorForm.cardNo')"
                                                autocomplete="off"
                                                placeholder=" "
                                                :error-messages="errors.card_no">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col
                                            cols="6">
                                            <label>{{ $vuetify.lang.t('$vuetify.visitorForm.gender') }}</label>
                                            <v-radio-group
                                                v-model="form.gender"
                                                row
                                                :rules="inputRules">
                                                <v-radio :label="$vuetify.lang.t('$vuetify.visitorForm.male')" value="M"></v-radio>
                                                <v-radio :label="$vuetify.lang.t('$vuetify.visitorForm.female')" value="F"></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field
                                                v-model="form.email"
                                                :label="$vuetify.lang.t('$vuetify.visitorForm.email')"
                                                autocomplete="off"
                                                placeholder=" "
                                                :rules="emailRules"
                                                :error-messages="errors.email">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field
                                                v-model="phoneNumberMask"
                                                :prefix="`(${prefixPhone})`"
                                                v-mask = "'## ### ####'"
                                                :label="$vuetify.lang.t('$vuetify.visitorForm.phoneNumber')"
                                                autocomplete="off"
                                                placeholder=" "
                                                :rules="inputRules">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="4">
                        <v-card class="visitor-access-info px-5 py-5 content-container">
                            <v-row>
                                <v-col>
                                    <span class="visitor-access-text locale-font">
                                        {{ $vuetify.lang.t('$vuetify.visitorForm.accessInformation') }}
                                    </span>
                                </v-col>
                            </v-row>
                            <v-row class="pt-3 my-3" justify="center">
                                <v-date-picker
                                    v-model="form.dates"
                                    :allowed-dates="allowedDates"
                                    multiple
                                ></v-date-picker>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.visitorForm.timeStart')"
                                        v-model="form.start_time"
                                        autocomplete="off"
                                        type="time"
                                        :rules="inputRules"
                                        :error-messages="errors.start_time"
                                        placeholder=" ">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.visitorForm.timeEnd')"
                                        v-model="form.end_time"
                                        autocomplete="off"
                                        type="time"
                                        :rules="inputRules"
                                        :error-messages="errors.end_time"
                                        placeholder=" ">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import profileDefault from '@/assets/user_default.png'
import Profile from '@/components/Profile'
export default {
    name: 'VisitorForm',

    directives: {
        mask
    },

    components: {
        Profile
    },

    data () {
        return {
            form: {
                image: profileDefault,
                name: '',
                surname: '',
                email: '',
                gender: '',
                citizen_id: '',
                phone_no: '',
                dates: [],
                card_no: ''
            },
            prefixPhone: '+66',
            phoneNumberMask: '',
            errors: {},
            minDate: '',
            valid: true,
            inputRules: [
                v => this.$validator.hasValue(v, this.$vuetify.lang.t('$vuetify.visitorForm.msgRequiredField')),
                v => this.$validator.lengthNotExceed(v, 255, this.$vuetify.lang.t('$vuetify.visitorForm.msgExceededField'))
            ],
            emailRules: [
                vmail => this.$validator.hasValue(vmail, this.$vuetify.lang.t('$vuetify.visitorForm.msgRequiredEmail')),
                vmail => this.$validator.lengthNotExceed(vmail, 255, this.$vuetify.lang.t('$vuetify.visitorForm.msgExceededEmail')),
                vmail => this.$validator.correctFormat(vmail, /.+@.+\..+/, this.$vuetify.lang.t('$vuetify.visitorForm.msgInvalidEmailFormat'))
            ],
            countError: 0,
            branchId: null,
            visitorId: null,
            operationMode: null,
            prevImg: null
        }
    },

    computed: {
        headerText () {
            if (this.operationMode === 'create') {
                return this.$vuetify.lang.t('$vuetify.visitorForm.createNewVisitor')
            } else if (this.operationMode === 'edit') {
                return this.$vuetify.lang.t('$vuetify.visitorForm.updateVisitor')
            }
            return ''
        },
        errorMsg () {
            return this.$vuetify.lang.t('$vuetify.visitorForm.msgError')
        },
        congratulationTitle () {
            return this.$vuetify.lang.t('$vuetify.visitorForm.congratulation')
        },
        warningTitle () {
            return this.$vuetify.lang.t('$vuetify.visitorForm.warning')
        },
        errorTitle () {
            return this.$vuetify.lang.t('$vuetify.visitorForm.error')
        },
        msgErrorImageSize () {
            return {
                title: this.errorMsg,
                text: this.$vuetify.lang.t('$vuetify.visitorForm.msgErrorImageSize'),
                type: 'error'
            }
        },
        msgErrorEnddate () {
            return {
                title: this.errorMsg,
                text: this.$vuetify.lang.t('$vuetify.visitorForm.endDateIsPassed'),
                type: 'error'
            }
        }
    },

    methods: {
        displayNoti (listMsg) {
            // for object to display response noti
            for (const property in listMsg) {
                let type = ''
                let title = ''
                if (listMsg[property].status === 'ok') {
                    title = this.congratulationTitle
                    type = 'success'
                } else if (listMsg[property].status === 'warning') {
                    title = this.warningTitle
                    type = 'warn'
                } else if (listMsg[property].status === 'error') {
                    title = this.errorTitle
                    type = 'error'
                }
                this.$notify({
                    title: title,
                    text: listMsg[property].msg,
                    type: type
                })
            }
        },

        checkRespose (res) {
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                const listMsg = res.data.data
                this.displayNoti(listMsg)

                this.$router.push({ name: 'Visitor' }, () => {})
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)
                for (const property in this.errors) {
                    this.$notify({
                        title: this.errorMsg,
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        changeProfileImg (event) {
            const fileList = event.target.files
            const maxFileSize = 200000
            const minFileSize = 25000

            const reader = new FileReader()

            if (fileList[0] && (fileList[0].size < minFileSize || fileList[0].size > maxFileSize)) {
                this.$notify(this.msgErrorImageSize)
            } else {
                if (fileList[0]) {
                    reader.onload = async () => {
                        // reader.result is base64
                        this.form.image = reader.result
                    }
                    reader.readAsDataURL(fileList[0])
                }
            }
        },

        cancel () {
            this.$router.push({ name: 'Visitor' }, () => {})
        },

        cleanForm () {
            const keys = ['name', 'surname', 'email', 'citizen_id', 'card_no']
            for (let i = 0; i < keys.length; i++) {
                this.form[keys[i]] = this.form[keys[i]].trim()
            }
        },

        async submit () {
            if (!this.$refs.form.validate()) {
                return
            }

            this.cleanForm()

            if (this.operationMode === 'create') {
                await this.createVisitor()
            } else if (this.operationMode === 'edit') {
                await this.updateVisitor()
            }
        },

        async getVisitor (id) {
            this.$store.dispatch('setLoading', true)
            const url = `visitor/${id}`
            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                const response = res.data.data
                this.form = response

                // remove '+66'
                this.phoneNumberMask = response.phone_no.slice(3)

                // if image does not exist, it must show default
                if (!response.image) {
                    this.form.image = profileDefault
                    this.prevImg = profileDefault
                } else {
                    this.prevImg = response.image
                }
            }
        },

        async updateVisitor () {
            this.$store.dispatch('setLoading', true)
            const form = {
                name: this.form.name,
                surname: this.form.surname,
                email: this.form.email,
                gender: this.form.gender,
                citizen_id: this.form.citizen_id,
                phone_no: `${this.prefixPhone} ${this.phoneNumberMask}`,
                start_time: this.form.start_time,
                end_time: this.form.end_time,
                branch_id: this.branchId,
                dates: this.form.dates,
                card_no: this.form.card_no
            }

            // change image for updating case
            if (this.prevImg !== this.form.image) {
                form.image = this.form.image
            }

            const res = await this.axios.put(`visitor/edit/${this.visitorId}`, form)

            this.checkRespose(res)
        },

        async createVisitor () {
            this.$store.dispatch('setLoading', true)

            const form = {
                name: this.form.name,
                surname: this.form.surname,
                email: this.form.email,
                gender: this.form.gender,
                citizen_id: this.form.citizen_id,
                phone_no: `${this.prefixPhone} ${this.phoneNumberMask}`,
                start_time: this.form.start_time,
                end_time: this.form.end_time,
                branch_id: this.branchId,
                dates: this.form.dates,
                card_no: this.form.card_no
            }

            // change image for creating case
            if (profileDefault !== this.form.image) {
                form.image = this.form.image
            }

            const res = await this.axios.post('visitor/create', form)

            this.checkRespose(res)
        },

        setMinDate () {
            const now = new Date()
            const nextDate = now.setDate(now.getDate())
            this.minDate = new Date(nextDate).toISOString().substr(0, 10)
        },

        async getBranchId () {
            if (localStorage.getItem('currentBranchId')) {
                this.branchId = localStorage.getItem('currentBranchId')
            }
        },

        allowedDates (date) {
            return date >= this.minDate
        }
    },

    async mounted () {
        this.setMinDate()
        await this.getBranchId()

        this.visitorId = this.$route.params.id

        if (this.visitorId) {
            await this.getVisitor(this.visitorId)
            this.operationMode = 'edit'
        } else {
            this.operationMode = 'create'
        }
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.$util.recheckValidate(this.$refs.form.inputs)
            },
            deep: true
        },
        'form.card_no': function (value) {
            if (!value || value?.length <= 10) {
                this.errors.card_no = ''
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
    font-size: 28px;
    font-weight: bold;
}
.visitor-profile, .visitor-access-info {
    border-radius: 15px;
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
    background-color: #ffffff;
}
.visitor-profile-text, .visitor-access-text {
    font-size: 24px;
}
.visitor-profile-text-box {
    display: flex;
}
.image-size-info {
    font-size: 9px;
    color: gray;
}
</style>
